import { Tooltip } from '@app/components/various/Tooltip';
import { cn } from '@app/utils/cn';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { isDefined } from '@app/utils/is';
import { PolymorphicComponentProps } from '@typings';
import React from 'react';

type Props<T extends React.ElementType> = PolymorphicComponentProps<T, { className: string }>;

export const CollapsibleTooltipCell = <T extends React.ElementType = 'span'>(props: React.PropsWithChildren<Props<T>>) => {
  const { children, className, as, ...rest } = props;
  const containerRef = React.useRef<HTMLDivElement>(null);
  const isOverflowing = useIsOverflowing(containerRef, { widthOnly: true });
  const Component = isDefined(as) ? as : 'span';

  return (
    <Tooltip content={isOverflowing && children}>
      <Component ref={containerRef} className={cn('truncate', className)} {...rest}>
        {children}
      </Component>
    </Tooltip>
  );
};
